import React from 'react';
import LandingPageTemplate from '../../components/LandingPageTemplate';
import {
  AttachMoney as MoneyIcon,
  Timeline as TimelineIcon,
  Cloud as CloudIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';
import heroImage from '../../assets/images/hpe_servers/HPE CloudOps Software.png';

const HPEGreenLakeLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      headline="IT as a Service with HPE GreenLake"
      subheadline="Get cloud flexibility and economics with on-premises control. Pay only for what you use with HPE GreenLake."
      heroImage={heroImage}
      ctaText="Get a Quote"
      valueProps={[
        'Pay-Per-Use Pricing',
        'On-Premises Control',
        'Cloud Flexibility',
        'Predictable Billing',
        'No CapEx Required',
        'Built-in Scalability',
      ]}
      features={[
        {
          title: 'Consumption-Based Pricing',
          description:
            'Pay only for the resources you actually use. Eliminate overprovisioning and reduce costs by up to 30% with flexible, metered billing.',
          icon: <MoneyIcon />,
        },
        {
          title: 'On-Premises Deployment',
          description:
            'Keep your data on-site for security and compliance while enjoying cloud-like flexibility. Perfect for regulated industries and data sovereignty requirements.',
          icon: <SecurityIcon />,
        },
        {
          title: 'Unified Cloud Experience',
          description:
            'Manage all your infrastructure—edge, on-premises, and cloud—from a single platform. HPE GreenLake Central provides complete visibility and control.',
          icon: <CloudIcon />,
        },
        {
          title: 'Built-in Capacity Buffer',
          description:
            'HPE includes extra capacity buffer so you can scale instantly when needed. No waiting for procurement or installation.',
          icon: <TimelineIcon />,
        },
      ]}
      stats={[
        { value: '30%', label: 'Cost Savings' },
        { value: '1400+', label: 'Customers' },
        { value: '0%', label: 'CapEx Required' },
        { value: '15%', label: 'Built-in Buffer' },
      ]}
      ctaHeadline="Ready to Move to Consumption-Based IT?"
      ctaDescription="Get a free assessment and TCO analysis from TNCOSOFT's HPE GreenLake specialists."
      primaryColor="#01A982"
      accentColor="#017A5F"
    />
  );
};

export default HPEGreenLakeLanding;
